import { urls } from "../api/api.urls";
import { makeRequestBaseUrl } from "../api/make.request";

export default class AdminServiceV2 {
  static async getCenters(examId: string) {
    return await makeRequestBaseUrl(urls.adminV2.getCenters + "/" + examId, "get");
  }
  
  static async getCenterInvList(examId:string){
    return await makeRequestBaseUrl(urls.adminV2.getCenterInvList + "/" + examId, "get");
  }

  static async creaetCenterInv(examId:string){
    return await makeRequestBaseUrl(urls.adminV2.createCenterInvList + "/" + examId, "post");
  }
}
